module.exports = __webpack_public_path__ + "static/media/guidance_4.5fcf5b3d.png";